import { gql } from '@apollo/client';

export const CreatePortalSession = gql`
    mutation createPortalSession($manageType: String! = "") {
        createPortalSession(manageType: $manageType) {
            success
            error
            portalSessionUrl
        }
    }
`;
